module.exports = __webpack_public_path__ + "static/media/www.aromatics.com.e6db4772.png";